module.exports = __webpack_public_path__ + "static/media/background-7.fc68515e.jpg";